export default "__VITE_ASSET__9b34e878__"